import { Box, Text } from '@backstage/ui';
import { ReactNode } from 'react';

type Props = {
  title: string;
  marginY?: '6' | '8';
  children: ReactNode;
};

export const HomeSection = ({ title, marginY = '6', children }: Props) => (
  <Box as="section" my={marginY}>
    <Text as="h2" variant="title-small" weight="bold">
      {title}
    </Text>
    <Box mt="6">{children}</Box>
  </Box>
);
